import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    flex: 0.5,
    maxWidth: 250,
  },
}));
